'use client';
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface Props {
  mesAnterior: string;
  mesAtual: string;
  totalAnterior: number;
  totalAtual: number;
  totalPago: number;
}

function CustomTooltip({ active, payload, label }: { active?: boolean; payload?: Array<{ name: string; value: number; fill: string }>; label?: string }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg shadow-lg px-3 py-2.5 text-sm">
      <p className="font-semibold text-foreground mb-2">{label}</p>
      {payload.map((p, i) => (
        <div key={`evo-tooltip-${i}`} className="flex items-center justify-between gap-4">
          <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: p.fill }} />
            {p.name}
          </span>
          <span className="font-medium tabular-nums text-xs text-foreground">
            € {p.value.toLocaleString('pt-PT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function BalanceEvolutionChart({
  mesAnterior, mesAtual, totalAnterior, totalAtual, totalPago
}: Props) {
  const data = [
    { mes: mesAnterior.replace(' 2026', ''), saldo: totalAnterior },
    { mes: mesAtual.replace(' 2026', ''), saldo: totalAtual },
  ];

  return (
    <div className="space-y-4">
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data} margin={{ top: 4, right: 8, left: 8, bottom: 4 }} barSize={48}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
          <XAxis
            dataKey="mes"
            tick={{ fontSize: 12, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${(v / 1_000_000).toFixed(1)}M`}
            width={40}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--muted)', opacity: 0.4 }} />
          <Bar dataKey="saldo" name="Total em Dívida" fill="var(--primary)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>

      {/* Summary stat */}
      <div className="bg-positive-subtle border border-green-200 rounded-lg px-4 py-3 flex items-center justify-between">
        <span className="text-xs text-muted-foreground font-medium">Redução total no mês</span>
        <span className="text-sm font-bold text-positive tabular-nums">
          € {totalPago.toLocaleString('pt-PT', { minimumFractionDigits: 2 })}
        </span>
      </div>
    </div>
  );
}